/**
 *
 * Validação se o valor introduzido é
 * um url.
 *
 * @param {String} value
 * @output {Boolean}
 *
*/

const validateWebsite = value => {
    // eslint-disable-next-line
    const regex = /https?:\/\/w{0,3}\w*?\.(\w*?\.)?\w{2,3}\S*|www\.(\w*?\.)?\w*?\.\w{2,3}\S*|(\w*?\.)?\w*?\.\w{2,3}[\/\?]\S*/;

    return regex.test( value );
};

export default {
    validateWebsite
};